// extracted by mini-css-extract-plugin
export var cardHeader = "_g8-0";
export var reorderHandle = "_g8-3";
export var titleArea = "_g8-1";
export var titleAreaWithHandle = "_g8-2";